import { KeywordPerformanceScores } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/ContentServerProxy/types';
import { ChartDataAdapter } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/Summary/Visualizations/adapters/types';
import { GaugeData, KeywordFilter, KeywordPerformanceGaugeData } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/Summary/Visualizations/types';
import { calculatePercentChange, safeDivide } from 'src/utils/app';
import { METRICTYPE } from 'src/utils/entityDefinitions';

export class KeywordsPerformanceSummaryAdapter implements ChartDataAdapter<KeywordPerformanceGaugeData> {
  mainScores: KeywordPerformanceScores;

  comparisonScores: KeywordPerformanceScores;

  constructor(mainScores: KeywordPerformanceScores, comparisonScores: KeywordPerformanceScores) {
    this.mainScores = mainScores;
    this.comparisonScores = comparisonScores;
  }

  transform(isProductEntity: boolean = false): KeywordPerformanceGaugeData {
    const gaugeData: GaugeData[] = [
      {
        percentage: this.mainScores.keywordUsageScore, // main donut chart value
        change: calculatePercentChange(this.mainScores.averageCountOfKeywords, this.comparisonScores.averageCountOfKeywords),
        value: this.mainScores.averageCountOfKeywords,
        valueMetricFormatter: {
          valueMetricType: METRICTYPE.DECIMAL,
          showFullValue: false,
          decimalPlaces: isProductEntity ? 0 : 1
        },
        filterKey: KeywordFilter.Usage // group 1 (Usage)
      },
      {
        value: safeDivide(this.mainScores.expectedKeywordsCount, this.mainScores.totalProducts, 0),
        valueMetricFormatter: {
          valueMetricType: METRICTYPE.DECIMAL,
          showFullValue: false,
          decimalPlaces: isProductEntity ? 0 : 1
        },
        valueSuffix: 'per page',
        filterKey: KeywordFilter.KeywordBenchmark // group 1 (Usage)
      },
      {
        value: this.mainScores.productsWithLowKeywordUsageScore / this.mainScores.totalProducts,
        valueSuffix: 'of products',
        valueMetricFormatter: {
          valueMetricType: METRICTYPE.PERCENT,
          showFullValue: false,
          decimalPlaces: 0
        },
        filterKey: KeywordFilter.LowUsage // group 1 (Usage)
      },
      {
        percentage: this.mainScores.keywordProductivityScore, // main donut chart value
        change: calculatePercentChange(this.mainScores.averageCountOfKeywordsGeneratingTraffic, this.comparisonScores.averageCountOfKeywordsGeneratingTraffic),
        value: this.mainScores.averageCountOfKeywordsGeneratingTraffic,
        valueMetricFormatter: {
          valueMetricType: METRICTYPE.DECIMAL,
          showFullValue: false,
          decimalPlaces: isProductEntity ? 0 : 1
        },
        filterKey: KeywordFilter.Productivity // group 2 (Productivity)
      },
      {
        change: calculatePercentChange(this.mainScores.averageUnproductiveKeywordsCount, this.comparisonScores.averageUnproductiveKeywordsCount),
        value: this.mainScores.averageUnproductiveKeywordsCount,
        valueMetricFormatter: {
          valueMetricType: METRICTYPE.DECIMAL,
          showFullValue: false,
          decimalPlaces: isProductEntity ? 0 : 1
        },
        filterKey: KeywordFilter.UnProductiveKeywords // group 2 (Productivity)
      },
      {
        value: this.mainScores.productsWithLowKeywordProductivityScore / this.mainScores.totalProducts,
        valueSuffix: 'of products',
        valueMetricFormatter: {
          valueMetricType: METRICTYPE.PERCENT,
          showFullValue: false,
          decimalPlaces: 0
        },
        filterKey: KeywordFilter.LowProductivity // group 2 (Productivity)
      },
      {
        percentage: this.mainScores.keywordPopularityScore, // main donut chart value
        change: calculatePercentChange(this.mainScores.averageVolumeOfSearchTraffic, this.comparisonScores.averageVolumeOfSearchTraffic),
        value: this.mainScores.averageVolumeOfSearchTraffic,
        valueMetricFormatter: {
          valueMetricType: METRICTYPE.VOLUME,
          showFullValue: false,
          decimalPlaces: isProductEntity ? 0 : 1
        },
        filterKey: KeywordFilter.Popularity // group 3 (Popularity)
      },
      {
        change: calculatePercentChange(this.mainScores.averageReferenceKeywordPopularity, this.comparisonScores.averageReferenceKeywordPopularity),
        value: this.mainScores.averageReferenceKeywordPopularity,
        filterKey: KeywordFilter.PopularityBenchmark, // group 3 (Popularity)
        valueMetricFormatter: {
          valueMetricType: METRICTYPE.VOLUME,
          showFullValue: false,
          decimalPlaces: isProductEntity ? 0 : 1
        }
      },
      {
        value: this.mainScores.productsWithLowKeywordPopularityScore / this.mainScores.totalProducts,
        valueSuffix: 'of products',
        valueMetricFormatter: {
          valueMetricType: METRICTYPE.PERCENT,
          showFullValue: false,
          decimalPlaces: 0
        },
        filterKey: KeywordFilter.LowPopularity // group 3 (Popularity)
      }
    ];

    return {
      gaugeData,
      mainScores: this.mainScores,
      comparisonScores: this.comparisonScores
    };
  }
}
